module.exports = __webpack_public_path__ + "img/13.8aff5e5f.png";